import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const BrandList = () => {
  const [BrandUser, setBrandUser] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/Brand_list"
      );
      setBrandUser(response.data.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_brand",
        { brand_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === "1") {
        setBrandUser((prevUser) =>
          prevUser.filter((user) => user.brand_id !== userId)
        );
        toast.error(response.data.message || "Data Deleted Successfully!");
        navigate("/brand-list");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete Brand.");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Brand / Manufacturer</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Brand</a>
                </li>
                <li className="breadcrumb-item active">Brand List</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="d-flex card-header justify-content-between align-items-center">
                <h4 className="card-title">All Brands</h4>
                <Link to="/brand-add" className="btn btn-sm btn-primary">
                  Add Brand
                </Link>
              </div>

              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table align-middle mb-0 table-hover table-centered">
                    <thead className="bg-light-subtle">
                      <tr>
                        <th>Sr. No</th>
                        <th>Brand Logo</th>
                        <th>Brand Name</th>
                        <th>Manufacturer Name</th>
                        <th>State</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {BrandUser.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>
                            <img
                              src={`https://cyberathon.com/multivendor/${item.brand_logo}`}
                              alt={item.brand_name}
                              style={{ width: "50px", height: "auto" }}
                            />
                          </td>
                          <td>{item.brand_name}</td>
                          <td>{item.manuf_name}</td>
                          <td>{item.manuf_state}</td>
                          <td>
                            <span
                              className={`badge ${
                                item.status === "active"
                                  ? "bg-success-subtle text-success"
                                  : "bg-danger-subtle text-danger"
                              } py-1 px-2`}
                            >
                              {item.status}
                            </span>
                          </td>
                          <td>
                            <div className="d-flex gap-2">
                              <Link to={`/brand-view/${item.brand_id}`} className="btn btn-light btn-sm">
                                <i className="fa-solid fa-eye fs-16"></i>
                              </Link>
                              <Link
                                to={`/brand-edit/${item.brand_id}`}
                                className="btn btn-soft-primary btn-sm"
                              >
                                <i className="fa-solid fa-pencil fs-16"></i>
                              </Link>
                              <span onClick={(e) => deleteUser(item.brand_id)}
                                className="btn btn-soft-danger btn-sm"
                              >
                                <i className="fa-solid fa-trash fs-16"></i>
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Pagination */}
              <div className="card-footer border-top">
                <nav>
                  <ul className="pagination justify-content-end mb-0">
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        Previous
                      </a>
                    </li>
                    <li className="page-item active">
                      <a className="page-link" href="javascript:void(0);">
                        1
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        2
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 text-center">
                © Venton. Crafted by{" "}
                <iconify-icon
                  icon="iconamoon:heart-duotone"
                  className="fs-18 align-middle text-danger"
                />{" "}
                <a href="#" className="fw-bold footer-text" target="_blank">
                  Techzaa
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default BrandList;
